import { Component, Input, OnChanges, OnDestroy, OnInit, SimpleChanges } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { doGetPromise } from '../../core/config/core.httpclient-utils';
import { TrackerTicklerService } from './tracker.tickler.service';

import { PollService } from '../../core/services/core.poll.service';
import { NotificationService } from '../../core/services/core.notification.service';
import { UiService } from '../../core/services/core.ui.service';
import { GfTranslateService } from '../../core/services/core.translate.service';

import * as _ from 'lodash';

@Component({
    selector: 'tickler-bar',
    template: require('./ticklerbar.component.html')
})
export class TicklerBarComponent implements OnInit, OnChanges, OnDestroy {

    @Input() section: string;
    @Input() refId: string;
    @Input() active: boolean = false;
    @Input() target: string = '_blank';

    private project: any = null;
    private ticklers = [];
    protected displayTicklers = [];
    private previousTicklerCounts: any = {};
    protected queryTree: any = false;
    protected treeId: string = 'tickler-selector-tree';
    protected selectedNewQuery: { section?: string, id: string } = null;

    constructor(
        private httpClient: HttpClient,
        private trackerTicklerService: TrackerTicklerService, 
        private pollService: PollService, 
        private notificationService: NotificationService,
        private uiService: UiService,
        private gfTranslateService: GfTranslateService
    ) {}
    
    ngOnInit() {
        this.notificationService.subscribe('tickler-bar', 'TICKLER-DATA-UPDATED', (args) => this.updateTicklers(args));
    }

    ngOnDestroy(): void {
        this.notificationService.unsubscribe('tickler-bar');        
    }

    ngOnChanges(changes: SimpleChanges): void {
        if (changes.refId && this.section == 'project') {
            this.pollService.cancelCurrent();
            this.pollService.replace('tickler', 'project', this.refId, 'x');
            this.pollService.run();

            // /api/project/:unixName/details?:querystring
            const url = `/api/project/${ this.refId }/details?:querystring`;
            doGetPromise(this.httpClient, url, { rel: 'trackers,permissions' })
                .then((response) => {
                    this.project = response;

                    this.getProjectQueries(this.refId)
                        .then((queries) => {
                            this.queryTree = this.trackerTicklerService.getQueryTree(
                                response, queries
                            );
                        });
                }, (response) => { console.log(response); });
        }
    };

    getProjectQueries(project_id) {
        var params = {
            projectId: project_id,
            selectedTracker: 0,
            page_size: 999
        };

        const url = '/api/tracker/0/queries';
        return doGetPromise(this.httpClient, url, params)
            .then((data) => {
                return _.get(data, 'items', []);
            });
    }

    updateTicklers(args) {
        if (args.section == this.section && args.refId == this.refId) {
            this.ticklers = _.get(args, 'ticklers', {});
            const queryTicklers = _.get(this.ticklers, 'queryTicklers', []);

            this.displayTicklers = this.trackerTicklerService.addUrlToTicklers(
                this.trackerTicklerService.getDisplayTicklers(    
                    queryTicklers
                )
            );

            //Set ticklers counts object
            this.previousTicklerCounts = this.trackerTicklerService.getTicklerCountMap(queryTicklers);
        }
    }

    // This is how you wire up callback functions
    addTickler = (query): boolean => {

        if (!query || query.children) {
            return false;
        }

        this.pollService.pause();

        this.resumePolling(
            this.trackerTicklerService.addTickler(query),
            'added', query
        ).then(
            () => {

                // Fake the tickler in until server returns it
                this.displayTicklers = this.trackerTicklerService.addUrlToTicklers(
                    this.trackerTicklerService.getDisplayTicklers(    
                        _.concat(
                            this.displayTicklers, {
                                "queryName": query.name,
                                "id": query.id,
                                "count": '...',
                                "project": this.refId,
                                "tracker": query.tracker.id,
                                "trackerName": query.tracker.name
                            }
                        )
                    )
                );
    
                this.uiService.message.showSuccess(
                    this.gfTranslateService.translate(
                        "Added {{trackerName}}:{{queryName}} to your tickler list", {
                            trackerName: query.tracker.name,
                            queryName: query.name
                        }
                    ),
                    this.gfTranslateService.translate('Add Query Tickler')
                );
            }
        );

        return true;
    }

    removeTickler = (tickler, $ev): void => {
        if ($ev) {
            $ev.preventDefault();
            $ev.stopPropagation();
        }

        this.pollService.pause();

        this.resumePolling(
            this.trackerTicklerService.removeTickler(tickler),
            'removed', tickler
        ).then(() => {
            this.displayTicklers = _.without(this.displayTicklers, tickler);
            this.uiService.message.showSuccess(
                this.gfTranslateService.translate(
                    "Removed {{trackerName}}:{{queryName}} from your tickler list", tickler
                ),
                this.gfTranslateService.translate('Remove Query Tickler')
            );
        });
    }

    resumePolling = (promise, action: string, obj: any): any => {
        return promise.then(
            () => {
                console.log(action, obj);
                this.trackerTicklerService.refreshPolling(this.section, this.refId);
            },
            (err) => {
                console.log(err);
            }
        ).finally(() => {
            this.pollService.run();
        });
    }

    trackById(index: number, item: any): any {
        return item.id;
    }
}
